import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { IPushNotificationsPanelButtonProps } from './types';
import { BOARD_SECTION_PUSH_NOTIFICATIONS } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';
import { CLASS_BOARD_DETAILS_SECTION } from '../../../../constants';

export function PushNotificationsPanelButton ({
    indicatorBoolean,
    isBoardSplitSettings,
    tooltip,
    onClick
}: IPushNotificationsPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            indicatorBoolean={indicatorBoolean}
            isOpened={isBoardSplitSettings && subTab === EBoardSetting.APP_NOTIFICATIONS}
            title={BOARD_SECTION_PUSH_NOTIFICATIONS}
            sectionSelector={!isBoardSplitSettings && `.${CLASS_BOARD_DETAILS_SECTION}--notifications`}
            tooltip={tooltip}
            onClick={() => {
                if (isBoardSplitSettings) setSubTab(EBoardSetting.APP_NOTIFICATIONS);
                onClick();
            }}
        />
    );
}
